<script setup lang="ts">
const { profile } = useAppConfig()
</script>

<template>
  <div
    class="relative z-10 mx-auto aspect-[180/208] w-56"
  >
    <!-- disc -->
    <div class="hero-disc absolute inset-x-0 bottom-0 aspect-square rounded-full bg-gradient-to-br from-[#4b5a50] to-[#1d2522]" />
    <!-- the bottom is clipped to the disc, the head stays free above it -->
    <div class="absolute inset-0 overflow-hidden rounded-b-full">
      <NuxtImg
        src="/assets/portrait.webp"
        width="442"
        densities="x1"
        :alt="profile.name"
        class="hero-portrait absolute -bottom-[6.73%] -left-[4.4%] w-[108.9%] max-w-none"
      />
    </div>
  </div>
</template>
